import { create } from 'zustand';

interface ICompetitionModeData {
  attempts: number;
  final: boolean;
  user_tg_id: number;
  score: number;
  distance: string;
  location: ICompetitionModeLocation;
  guessed_latitude: string | null;
  guessed_longitude: string | null;
  id: string;
}

interface ICompetitionModeLocation {
  activeDate: string;
  competitive: boolean;
  id: string;
  latitude: string;
  longitude: string;
  startTimeStamp: string;
  endTimeStamp: string;
}

interface ICompetitionModeResult {
  attempts: number;
  distance: string;
  score: number;
  final: boolean;
  message?: string;
}

interface IGeneralModeData {
  attempts: number;
  score: number;
  distance: string;
  location: IGeneralModeLocation;
}

interface IGeneralModeLocation {
  latitude: string;
  longitude: string;
  startTimeStamp: string;
  endTimeStamp: string;
}

interface IGeneralModeResult {
  attempts: number;
  distance: string;
  score: number;
  message?: string;
}

interface ICompetitionModeStatus {
  attempts: number;
  totalAttempts: number;
  score: number;
  final: boolean;
  lastAttemptDistance: string;
  lastAttemptScore: number;
}

interface IGeneralModeStatus {
  attempts: number;
  totalAttempts: number;
  score: number;
}

interface ITrainingModeData {
  attempts: number;
  score: number;
  distance: string;
  location: ITrainingModeLocation;
}

interface ITrainingModeLocation {
  latitude: string;
  longitude: string;
  startTimeStamp: string;
  endTimeStamp: string;
}

interface ITrainingModeResult {
  attempts: number;
  distance: string;
  score: number;
  message?: string;
}

export interface IGameStore {
  competitionModeData: ICompetitionModeData | null;
  setCompetitionModeData: (data: ICompetitionModeData) => void;
  generalModeData: IGeneralModeData | null;
  setGeneralModeData: (data: IGeneralModeData) => void;
  trainingModeData: ITrainingModeData | null;
  setTrainingModeData: (data: ITrainingModeData) => void;
  competitionModeResult: ICompetitionModeResult | null;
  setCompetitionModeResult: (data: ICompetitionModeResult) => void;
  generalModeResult: IGeneralModeResult | null;
  setGeneralModeResult: (data: IGeneralModeResult) => void;

  trainingModeResult: ITrainingModeResult | null;
  setTrainingModeResult: (data: ITrainingModeResult) => void;

  isFinishedCompetition: boolean;
  setIsFinishedCompetition: (data: boolean) => void;
  randomFact: string | null;
  setRandomFact: (data: string) => void;
  competitionModeStatus: ICompetitionModeStatus | null;
  setCompetitionModeStatus: (data: ICompetitionModeStatus) => void;
  generalModeStatus: IGeneralModeStatus | null;
  setGeneralModeStatus: (data: IGeneralModeStatus) => void;
  isCompetitionPlayedFirstTime: boolean;
  setIsCompetitionPlayedFirstTime: (data: boolean) => void;
  isGeneralPlayedFirstTime: boolean;
  setIsGeneralPlayedFirstTime: (data: boolean) => void;
  isTrainingPlayedFirstTime: boolean;
  setIsTrainingPlayedFirstTime: (data: boolean) => void;
}

export const useGameStore = create<IGameStore>((set) => ({
  competitionModeData: null,
  setCompetitionModeData: (data: ICompetitionModeData) =>
    set({ competitionModeData: data }),
  generalModeData: null,
  setGeneralModeData: (data: IGeneralModeData) =>
    set({ generalModeData: data }),
  trainingModeData: null,
  setTrainingModeData: (data: ITrainingModeData) =>
    set({ trainingModeData: data }),
  competitionModeResult: null,
  setCompetitionModeResult: (data: ICompetitionModeResult) =>
    set({ competitionModeResult: data }),
  generalModeResult: null,
  setGeneralModeResult: (data: IGeneralModeResult) =>
    set({ generalModeResult: data }),

  trainingModeResult: null,
  setTrainingModeResult: (data: ITrainingModeResult) =>
    set({ trainingModeResult: data }),

  isFinishedCompetition: false,
  setIsFinishedCompetition: (data: boolean) =>
    set({ isFinishedCompetition: data }),
  randomFact: null,
  setRandomFact: (data: string) => set({ randomFact: data }),
  competitionModeStatus: null,
  setCompetitionModeStatus: (data: ICompetitionModeStatus) =>
    set({ competitionModeStatus: data }),
  generalModeStatus: null,
  setGeneralModeStatus: (data: IGeneralModeStatus) =>
    set({ generalModeStatus: data }),
  isCompetitionPlayedFirstTime: true,
  setIsCompetitionPlayedFirstTime: (data: boolean) =>
    set({ isCompetitionPlayedFirstTime: data }),
  isGeneralPlayedFirstTime: true,
  setIsGeneralPlayedFirstTime: (data: boolean) =>
    set({ isGeneralPlayedFirstTime: data }),
  isTrainingPlayedFirstTime: true,
  setIsTrainingPlayedFirstTime: (data: boolean) =>
    set({ isTrainingPlayedFirstTime: data }),
}));
